import { mediasFields } from './composer'

export const getCollectivityBySlug = () => {
  return `query getCollectivityBySlug($slug: String!,$limit: Int = 10, $offset: Int = 0) {
  collectivityBySlug(slug: $slug,limit: $limit, offset: $offset) {
    title
    summary
    total
    medias {
      ${mediasFields}
    }
  }
  }`
}
